import { render } from "./QueueCounter.vue?vue&type=template&id=0c61ae14"
import script from "./QueueCounter.vue?vue&type=script&lang=js"
export * from "./QueueCounter.vue?vue&type=script&lang=js"

import "./QueueCounter.vue?vue&type=style&index=0&id=0c61ae14&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__